module.exports = __webpack_public_path__ + "static/media/FirstImage.f364d565.png";